export enum BatchEventType {
  CONTAMINATION = 'CONTAMINATION',
  FORCE_BATCH = 'FORCE_BATCH',
  OVER_TOLERANCE = 'OVER_TOLERANCE',
  IO_CHANGE = 'IO_CHANGE',
  INDICATOR_VALUE_ERROR = 'INDICATOR_VALUE_ERROR',
}
